import Link from "next/link"
import Skill from "@modules/Skill/components/Skill"
import { StyledButton } from "@modules/Common/styled"
import { PublicActivityPageQueriesQuery, StudentSkillsQuery } from "@generated/graphql"
import { ActivitySliderWrapper, StyledBox, StyledBoxHeader, StyledOverlay } from "../styled/Activity"

interface Props {
  title: string
  description: string
  skills: StudentSkillsQuery["studentSkills"] | PublicActivityPageQueriesQuery["publicActivitySkills"]
}

const settings = {
  infinite: false,
  speed: 500,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 625,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1,
      },
    },
  ],
}

export default function SkillsList({ title, description, skills }: Props) {
  return <>
    <StyledBox>
      <StyledBoxHeader>{title}</StyledBoxHeader>
      <img src="/assets/svg/activities-heading-small.svg" />
    </StyledBox>
    <StyledOverlay>
      <div style={{ fontWeight: 600, fontSize: "1.2rem" }} dangerouslySetInnerHTML={{ __html: description }} />
      <ActivitySliderWrapper {...settings}>
        {skills.map((skill) => <Skill key={skill.id} skill={skill} />)}
      </ActivitySliderWrapper>
      <div style={{ textAlign: "center" }}><Link href="/skills" legacyBehavior><StyledButton>ALL SKILLS</StyledButton></Link></div>
    </StyledOverlay>
  </>
}
